module.exports = __webpack_public_path__ + "static/media/step-2-colored.705766af.png";